import { render, staticRenderFns } from "./spider-table.vue?vue&type=template&id=008b40ff&scoped=true&"
import script from "./spider-table.vue?vue&type=script&lang=ts&"
export * from "./spider-table.vue?vue&type=script&lang=ts&"
import style0 from "./spider-table.vue?vue&type=style&index=0&id=008b40ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008b40ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDataTable,VList,VListItem,VListItemTitle,VMenu})
